import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClick: '&'
    },
    template: `
        <div class="burger ico-menu" ng-click="vm.toggleMenu($event)"></div>
        <style>
            learn-modal-topbar-burger {
                display: contents;
            }
        </style>
    `
})

export default class {
    toggleMenu ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.onClick) {
            this.onClick();
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/components/learnModal/topbar/burger/index.js